/**
 * @flow
 */
import {EgretLoadable} from "../../../egret";
import {ROUTE} from '../../settings';

const dashboardRoutes = [
  {path: ROUTE.DASHBOARD_OVERVIEW, component: EgretLoadable({loader: () => import("./DashboardHome")})},
  {path: ROUTE.DASHBOARD_MAP_VIEW, component: EgretLoadable({loader: () => import("./DashboardMapView")})},
  {path: ROUTE.DASHBOARD_CHART, component: EgretLoadable({loader: () => import("./DashboardChart")})},
  {path: ROUTE.DASHBOARD_LIST, component: EgretLoadable({loader: () => import("./DashboardList")})},
  // {path: ROUTE.DASHBOARD_PATIENTS_LIST, component: EgretLoadable({loader: () => import("./DashboardPatientsList")})},
  {path: ROUTE.DASHBOARD_NOTI, component: EgretLoadable({loader: () => import("./DashboardNoti")})},
];

export default dashboardRoutes;
